export default function getArrayIntersection(a: any[][]): any {
    if (a.length > 2) return getArrayIntersection([getArrayIntersection(a.slice(0, a.length / 2)), getArrayIntersection(a.slice(a.length / 2))]);

    if (a.length === 1) return a[0];

    return a[0].filter(function(item) {
        return a[1].indexOf(item) !== -1;
    });
}
